import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function NewsDetail() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    const [err, setErr] = useState("");

    useEffect(() => {
        api.get(`/news/${slug}`).then((r) => setArticle(r.data)).catch((e) => setErr("Not found"));
    }, [slug]);

    if (err) return <div className="max-w-3xl mx-auto px-5 py-32 text-center text-ink">{err}</div>;
    if (!article) return <div className="max-w-3xl mx-auto px-5 py-32 text-center text-ink">Loading…</div>;

    return (
        <article data-testid="news-detail-page" className="grain">
            <div className="relative h-[55vh] min-h-[380px] overflow-hidden">
                <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${article.cover_image || ""}')` }} />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/20" />
                <div className="relative max-w-4xl mx-auto px-5 md:px-10 h-full flex flex-col justify-end pb-12">
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold">
                        {new Date(article.published_at || article.created_at).toLocaleDateString("en-US", { month: "long", day: "2-digit", year: "numeric" })}
                    </div>
                    <h1 className="h-display text-4xl md:text-6xl mt-4">{article.title}</h1>
                </div>
            </div>
            <div className="max-w-3xl mx-auto px-5 md:px-10 py-16 text-lg leading-relaxed text-white/85" dangerouslySetInnerHTML={{ __html: article.body }} />
            <div className="max-w-3xl mx-auto px-5 md:px-10 pb-24">
                <Link to="/news" className="text-gold text-xs uppercase tracking-[0.3em] font-bold">← Back to News</Link>
            </div>
        </article>
    );
}
